import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import { Form, Row, Col, Modal, Container } from "react-bootstrap";
import * as Yup from "yup";
import { UserDataContext } from "../components/UserDataContext";
import { registerLocale } from "react-datepicker";
import { addDays, isAfter } from "date-fns";
import { format } from "date-fns";
import { useParams } from "react-router-dom";
import "../components/button.css";
import { TextField, FormControl } from "@mui/material";
import Alerts from "../components/Alerts";
import { marginBottom } from "../App";
import Button from "@mui/material/Button";
import BlockSharpIcon from "@mui/icons-material/BlockSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { pl } from "date-fns/locale";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import VN from "../components/VN";
import KeyIcon from "@mui/icons-material/Key";
import PassChangeUser from "./PassChangeUser";
import { apiRequest } from "../components/Config";
import LockIcon from "@mui/icons-material/Lock";

const validationSchema = () =>
  Yup.object().shape({
    user: Yup.string().required("Użytkownik jest wymagany"),
    fullName: Yup.string().required("Imię i nazwisko są wymagane"),
    city: Yup.string().required("Miejscowość jest wymagana"),
    selectedDate: Yup.date()
      .nullable()
      .required("Data jest wymagana")
      .test(
        "is-after-today",
        "Data musi być późniejsza niż dzisiaj",
        (value) => value && isAfter(value, new Date())
      ),
  });
registerLocale("pl", pl);

export default function EditUser() {
  const { id } = useParams();
  const { userData } = useContext(UserDataContext);
  const navigate = useNavigate();
  const [userUserData, setUserUserData] = useState({});
  const [userPermission, setUserPermission] = useState();
  const [disabled, setDisabled] = useState(false);
  const [initialFormValues, setInitialFormValues] = useState({
    user: "",
    fullName: "",
    city: "",
    company: "",
    nip: "",
    regon: "",
    email: "",
    phone: "",
    selectedDate: null,
    expire: "",
    is_active: "",
    permbuild: "",
    expertise: "",
    permId: "",
  });
  const [show, setShow] = useState(false);
  const [showPassChange, setShowPassChange] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleted, setDeleted] = useState(null);
  const [buttonText, setButtonText] = useState();
  const [apiResponse, setApiResponse] = useState({});
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setSelectedId(id);
    setShow(true);
  };
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [permissionsAll, setPermissionsAll] = useState([]);
  const ClearApiResponse = () => {
    setShowApiResponse(false);
  };
  const [selectedUsers, setSelectedUsers] = useState([]);
  const handleSubmit = async (values, { setSubmitting }) => {
    const formatted = format(values.selectedDate, "yyyy-MM-dd");
    values["expire"] = formatted;
    values["id"] = id;

    try {
      const response = await apiRequest(`edituser/${id}`, "POST", values);
      if (response.error_msg === 200) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Informacja",
          severity: "success",
          info: "Dane zaktualizowane!",
        });
      }
      if (response.error_msg === 559) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Uwaga",
          severity: "error",
          info: "Dane nie zostały zaktualizowane.",
        });
      }
      if (response.error_msg === 600) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Uwaga",
          severity: "error",
          info: "Błąd po stronie serwera. Skontaktuj się z Administratorem.",
        });
      }
    } catch (error) {
      setShowApiResponse(true);
      setApiResponse({
        title: "Uwaga",
        severity: "error",
        info: "Nie udało się zaktualizować!",
      });
      console.error("There was an error editing the user!", error);
    } finally {
      setSubmitting(false);
    }
  };
  const handleDelete = async () => {
    console.log("lock: ", id, deleted);
    try {
      const response = await apiRequest(`updateuser`, "POST", {
        id: id,
        is_active: deleted,
      });
      console.log("update deleted: ", response);
      // sprawdź response i w zależności od tego ustaw setDeleted
      setShow(false);
      setDeleted((prev) => (prev === 0 ? 1 : 0));
      setButtonText((prev) =>
        prev === "Przywróć dostęp" ? "Zablokuj" : "Przywróć dostęp"
      );
    } catch (error) {
      console.error("Błąd podczas próby zablokowania użytkownika:", error);
    }
  };

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest("getpossibilities", "GET");
          if (Array.isArray(response)) {
            setOptions(response);
          } else {
            setOptions([]);
          }
        } catch (error) {
          console.log(error.message);
        }
      };
      fetchData();
    }
  }, [userData, inputValue]);

  useEffect(() => {
    if (userData && !["1", "3"].includes(userData.permId)) {
      navigate("/nopermission");
    }
  }, [userData]);

  const handlePass = (id) => {
    setShowPassChange(!showPassChange);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest(`user/${id}`, "GET");
        if (response[0]) {
          setUserUserData(response[0]);
          setInitialFormValues({
            user: response[0].user || "",
            fullName: response[0].fullName || "",
            city: response[0].city || "",
            company: response[0].company || "",
            nip: response[0].nip || "",
            regon: response[0].regon || "",
            email: response[0].email || "",
            phone: response[0].phone || "",
            selectedDate: response[0].expire
              ? new Date(response[0].expire)
              : null,
            expire: response[0].expire || "",
            is_active: response[0].is_active || "",
            permbuild: response[0].permbuild || "",
            expertise: response[0].expertise || "",
            permId: response[0].permId || "",
          });
          setUserPermission(response[0].permId);
        }
      } catch (error) {
        console.log(error.message);
      }
    };
    if (userData && userData.userId) {
      fetchData();
    }
  }, [userData]);

  useEffect(() => {
    if (userPermission === "2") {
      setDisabled(true);
    }
  }, [userUserData, userPermission]);

  useEffect(() => {
    if (
      initialFormValues.is_active === "0" &&
      initialFormValues.is_active !== ""
    ) {
      setButtonText("Przywróć dostęp");
      setDeleted(1);
    }
    if (
      initialFormValues.is_active === "1" &&
      initialFormValues.is_active !== ""
    ) {
      setButtonText("Zablokuj");
      setDeleted(0);
    }
  }, [initialFormValues.is_active]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("permissions");
        if (userPermission !== "2") {
          const filteredData = response.filter((item) => item.id !== 2);
          setPermissionsAll(filteredData);
        } else {
          setPermissionsAll(response);
        }
      } catch (error) {
        console.log(error.message);
      }
    };

    if (userData && userData.userId) {
      fetchData();
      const intervalId = setInterval(fetchData, 100000);
      return () => clearInterval(intervalId);
    }
    if (userPermission === "2") {
      setReadOnly(true);
    }
  }, [userData, userPermission]);

  return (
    <div>
      <VN userData={userData} />
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potwierdzenie</Modal.Title>
        </Modal.Header>
        <Modal.Body>Czy na pewno ?</Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" onClick={handleClose}>
            Anuluj
          </Button>
          <Button variant="contained" onClick={handleDelete}>
            {deleted === 0 ? "Blokuj" : "Przywróć"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Container>
        <h4>Edycja Kontrahenta</h4>

        <Formik
          initialValues={initialFormValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ isSubmitting, setValues, values, handleChange }) => (
            <ThemeProvider theme={theme}>
              <FormikForm>
                <Row className="align-items-start" style={{ marginBottom }}>
                  <Col style={{ marginBottom }}>
                    <FormControl fullWidth>
                      <Field name="nip">
                        {({ field, meta }) => (
                          <TextField
                            {...field}
                            label="NIP firmy"
                            variant="standard"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <LockIcon fontSize="small" color="disabled" />
                              ),
                            }}
                          />
                        )}
                      </Field>
                    </FormControl>
                  </Col>
                  <Col style={{ marginBottom }}>
                    <FormControl fullWidth>
                      <Field name="regon">
                        {({ field, meta }) => (
                          <TextField
                            {...field}
                            label="REGON"
                            variant="standard"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <LockIcon fontSize="small" color="disabled" />
                              ),
                            }}
                          />
                        )}
                      </Field>
                    </FormControl>
                  </Col>
                </Row>
                <Row className="align-items-start" style={{ marginBottom }}>
                  <Col style={{ marginBottom }}>
                    <FormControl fullWidth>
                      <Field name="company">
                        {({ field, meta }) => (
                          <TextField
                            {...field}
                            label="Nazwa Firmy"
                            variant="standard"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <LockIcon fontSize="small" color="disabled" />
                              ),
                            }}
                          />
                        )}
                      </Field>
                    </FormControl>
                  </Col>
                </Row>

                <Row className="align-items-start" style={{ marginBottom }}>
                  <Col style={{ marginBottom }}>
                    <FormControl fullWidth>
                      <Field name="city">
                        {({ field, meta }) => (
                          <TextField
                            {...field}
                            label="Adres Firmy"
                            variant="standard"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                          />
                        )}
                      </Field>
                    </FormControl>
                  </Col>
                </Row>
                <Row className="align-items-start" style={{ marginBottom }}>
                  <Col style={{ marginBottom }}>
                    <FormControl fullWidth>
                      <Field name="user">
                        {({ field, meta }) => (
                          <TextField
                            {...field}
                            label="Konto logowania"
                            variant="standard"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <LockIcon fontSize="small" color="disabled" />
                              ),
                            }}
                          />
                        )}
                      </Field>
                    </FormControl>
                  </Col>
                  <Col style={{ marginBottom }}>
                    <FormControl fullWidth>
                      <Field name="fullName">
                        {({ field, meta }) => (
                          <TextField
                            {...field}
                            label="Osoba kontaktowa"
                            variant="standard"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                          />
                        )}
                      </Field>
                    </FormControl>
                  </Col>
                  <Col style={{ marginBottom }}>
                    <FormControl fullWidth>
                      <Field name="email">
                        {({ field, meta }) => (
                          <TextField
                            {...field}
                            label="E-mail"
                            variant="standard"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                          />
                        )}
                      </Field>
                    </FormControl>
                  </Col>
                  <Col style={{ marginBottom }}>
                    <FormControl fullWidth>
                      <Field name="phone">
                        {({ field, meta }) => (
                          <TextField
                            {...field}
                            label="Telefon"
                            variant="standard"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                          />
                        )}
                      </Field>
                    </FormControl>
                  </Col>
                  <Col md="2" style={{ marginBottom }}>
                    <FormControl fullWidth>
                      <Field name="selectedDate">
                        {({ field, form, meta }) => (
                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            adapterLocale={pl}
                          >
                            <DatePicker
                              label="Wybierz datę ważności konta"
                              value={field.value ? new Date(field.value) : null}
                              onChange={(newValue) => {
                                form.setFieldValue(
                                  field.name,
                                  newValue
                                    ? newValue.toISOString().slice(0, 10)
                                    : ""
                                );
                                ClearApiResponse();
                              }}
                              minDate={addDays(new Date(), 1)}
                              format="yyyy-MM-dd"
                              slotProps={{
                                textField: {
                                  variant: "standard",
                                  error: meta.touched && Boolean(meta.error),
                                  helperText: meta.touched && meta.error,
                                  fullWidth: true,
                                },
                              }}
                            />
                          </LocalizationProvider>
                        )}
                      </Field>
                    </FormControl>
                  </Col>
                </Row>

                {userPermission == 2 && <Row style={{ marginBottom }}></Row>}
                <Row className="align-items-start" style={{ marginBottom }}>
                  <Col className="d-flex align-items-center">
                    {userUserData &&
                      initialFormValues.is_active !== "" &&
                      id !== userData.userId && (
                        <Button
                          variant="outlined"
                          onClick={() => handleShow(id)}
                        >
                          <BlockSharpIcon />
                          {buttonText}
                        </Button>
                      )}
                  </Col>

                  <Col className="d-flex align-items-center">
                    <Button
                      variant="outlined"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      <EditSharpIcon />
                      Zapisz
                    </Button>
                  </Col>
                  <Col className="d-flex align-items-center">
                    <Button variant="outlined" onClick={() => handlePass(id)}>
                      <KeyIcon />
                      Ustaw hasło
                    </Button>
                  </Col>
                </Row>
              </FormikForm>
            </ThemeProvider>
          )}
        </Formik>
      </Container>
      {showPassChange && <PassChangeUser userId={id} />}
      <hr></hr>
      {userPermission == 2 && (
        <>
          <Container>
            <Row style={{ marginBottom }}></Row>
          </Container>
        </>
      )}
    </div>
  );
}
